(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function initRoyceEta() {
    document.querySelectorAll('[data-royce-eta]').forEach(function (panel) {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      var article = panel.closest('[data-section-type="product"]');
      var json = document.getElementById('ProductJson-' + panel.dataset.section);
      if (!article || !json) return;
      var product = JSON.parse(json.textContent);
      var purchase = article.querySelector('form[action*="/cart/add"]');
      if (!purchase) return;
      var enquiry = panel.querySelector('form');
      if (enquiry) enquiry.addEventListener('submit', function (event) {
        if (!enquiry.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          enquiry.reportValidity();
        }
      }, true);
      function refreshEta() {
        var selectors = Array.from(purchase.querySelectorAll('[data-option-selector]'));
        var idInput = purchase.querySelector('[name="id"]');
        var variant = selectors.length ? product.variants.find(function (item) {
          return selectors.every(function (select, index) { return item.options[index] === select.value; });
        }) : product.variants.find(function (item) { return String(item.id) === idInput.value; });
        if (!variant) { panel.hidden = true; return; }
        var feedback = panel.querySelector('[data-eta-success], [data-eta-errors]');
        panel.hidden = variant.available && !feedback;
        var sku = panel.querySelector('[data-eta-sku]');
        var option = panel.querySelector('[data-eta-option]');
        var url = panel.querySelector('[data-eta-url]');
        if (sku) sku.value = variant.sku || '';
        if (option) option.value = variant.title;
        if (url) url.value = location.origin + location.pathname + '?variant=' + variant.id;
        panel.querySelector('[data-eta-variant]').textContent = (variant.title === 'Default Title' ? '' : variant.title + ' · ') + (variant.sku || '');
        var returnTo = panel.querySelector('[name="return_to"]');
        if (returnTo) returnTo.value = location.pathname + '?variant=' + variant.id + '#' + panel.id;
        if (feedback) panel.open = true;
      }
      purchase.addEventListener('change', refreshEta);
      window.addEventListener('popstate', refreshEta);
      refreshEta();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRoyceEta);
  else initRoyceEta();
  document.addEventListener('shopify:section:load', initRoyceEta);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  function loadProductRecommendationsIntoSection() {
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection === null) {
      return;
    };
    var productId = productRecommendationsSection.dataset.productId;
    var limit = productRecommendationsSection.dataset.limit;
    var requestUrl = Station.Theme.shop.root + 'recommendations/products?section_id=product-recommendations&limit='+limit+'&product_id=' + productId;
    var request = new XMLHttpRequest();
    request.open('GET', requestUrl);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector('.product-recommendations').innerHTML;
        window.Station.Theme.Currency.init();
        window.Station.Theme.Cart.init();
      };
    };
    request.send();
  };
  document.addEventListener('DOMContentLoaded', function (event) {
    loadProductRecommendationsIntoSection();
  });
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'product-recommendations') {
      loadProductRecommendationsIntoSection();
    };
  });

  } catch(e) { console.error(e); }
})();
})();
